import { Component, HostBinding, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { NgClass } from '@angular/common';
import { TrackLinkDirective } from '@analytics/events';

import { ButtonModel } from './button.model';

@Component({
  selector: 'wl-button',
  templateUrl: './button.component.html',
  standalone: true,
  imports: [TrackLinkDirective, NgClass],
})
export class ButtonComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: ComponentRendering;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() config?: ButtonModel;

  @HostBinding('class')
  class = '';
}
